/* eslint-disable no-unused-vars */
/**
 * HTTP client.
 *
 * @see {@link https://github.com/axios/axios}
 * @module utils/axios
 */
import axios from "axios";
import * as urlUtils from "@/utils/url";
import { getAccessToken } from "./tokenService";

const config = {
  baseURL: urlUtils.getBaseApiURL(),
  timeout: 100000,
};

const instance = axios.create(config);

// Request interceptor to add Authorization only if needed
instance.interceptors.request.use(
  (config) => {
    if (config.requiresAuth) {
      const token = getAccessToken();
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// axios methods
const methods = {
  /**
   * request.
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  request(config) {
    throw new Error("Not Implemented");
  },

  /**
   * get.
   * @param {String} url Url
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  get(url, config) {
    return instance.get(url, config);
  },

  /**
   * delete.
   * @param {String} url Url
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  delete(url, config) {
    return instance.delete(url, config);
  },

  /**
   * head.
   * @param {String} url Url
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  head(url, config) {
    throw new Error("Not Implemented");
  },

  /**
   * options.
   * @param {String} url Url
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  options(url, config) {
    throw new Error("Not Implemented");
  },

  /**
   * post.
   * @param {String} url Url
   * @param {Object} data Data
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  post(url, data, config) {
    return instance.post(url, data, config);
  },

  /**
   * put.
   * @param {String} url Url
   * @param {Object} data Data
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  put(url, data, config) {
    return instance.put(url, data, config);
  },

  /**
   * patch.
   * @param {String} url Url
   * @param {Object} data Data
   * @param {Object} config Config
   * @return {Promise} Promise
   * @see {@link https://github.com/mzabriskie/axios#instance-methods}
   */
  patch(url, data, config) {
    return instance.patch(url, data, config);
  },
};

export default methods;

/**
 * Set access token.
 *
 * @param {String} token access token
 */
// export const setAccessToken = token => {
//   accessToken = token
// }

/**
 * Set error handler for axios instance.
 *
 * @param {Function} handler handler fucntion
 */
// export const setErrorHander = handler => {
//   errorHandler = handler
// }
